<script setup lang="ts">
import PriorityFilter from '@/components/common/PriorityFilter.vue'

const props = defineProps<{
  value: number[]
}>()

const emit = defineEmits<{ (e: 'input', value: number[]): void }>()

function updateValue(value: number[]) {
  emit('input', value)
}
</script>

<template>
  <priority-filter :dense="false" :selected-priorities="props.value" @on-change="updateValue" />
</template>

<style scoped></style>
